import { $activeLanguage } from '../store/Languages/store'
import { Content } from '../services/api/_type'
import { Common } from '../shared/enum'

export const getContent = (content?: Content[]) => {
  const { code } = $activeLanguage.getState()
  const result = content?.find(({ language }) => language.toLowerCase() === code?.toLowerCase())
  if (!result?.content) {
    const resultEn = content?.find(({ language }) => language.toLowerCase() === Common.DEFAULT_LANGUAGE)
    return resultEn?.content || ''
  }
  return result?.content || ''
}
